import React, { Component } from 'react';
import { BrowserRouter, Route, Switch } from 'react-router-dom'
import EnterPage from './enter.js';
import MainPage from './main.js';
import './App.scss';

class App extends Component {
	result_key = null;
	constructor(props){
		super(props);

		this.state = {
		}
	}

	render() {
		const enter = props=>React.createElement(
			EnterPage,
			{
				setResultKey:(id)=>this.setResultKey(id),
				...props,
			},
			null
			);
		const basename = process.env.REACT_APP_BASENAME;
		return (
			<React.Fragment>
				<BrowserRouter basename={basename}>
				<Switch>
					<Route exact path='/:id' render={enter}/>
					<Route exact path='/' render={() => <MainPage result_key={this.result_key} />}/>
				</Switch>
				</BrowserRouter>
			</React.Fragment>
		);
	}

	setResultKey( id ){
		this.result_key = id;
	}
}

export default App;
